/* eslint-disable @typescript-eslint/naming-convention */
export enum DistributionRegionsEnum {
    US = 'US',
    UK = 'UK',
    Canada = 'Canada',
    NorthAmerica = 'NorthAmerica'
}
